import type { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

const ICON_STYLES = {
  valid: {
    path: 'M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM14.6339 8.38388C15.122 7.89573 15.122 7.10427 14.6339 6.61612C14.1457 6.12796 13.3543 6.12796 12.8661 6.61612L8.75 10.7322L7.13388 9.11612C6.64573 8.62796 5.85427 8.62796 5.36611 9.11612C4.87796 9.60427 4.87796 10.3957 5.36611 10.8839L7.86611 13.3839C8.35427 13.872 9.14573 13.872 9.63388 13.3839L14.6339 8.38388Z',
    fill: 'fill-success-500',
  },
  warning: {
    path: 'M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM11.25 15C11.25 15.6904 10.6904 16.25 10 16.25C9.30964 16.25 8.75 15.6904 8.75 15C8.75 14.3096 9.30964 13.75 10 13.75C10.6904 13.75 11.25 14.3096 11.25 15ZM10 3.75C9.30964 3.75 8.75 4.30964 8.75 5V10C8.75 10.6904 9.30964 11.25 10 11.25C10.6904 11.25 11.25 10.6904 11.25 10V5C11.25 4.30964 10.6904 3.75 10 3.75Z',
    fill: 'fill-warning-500',
  },
  danger: {
    path: 'M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM8.38388 6.61612C7.89573 6.12796 7.10427 6.12796 6.61612 6.61612C6.12796 7.10427 6.12796 7.89573 6.61612 8.38388L8.23223 10L6.61612 11.6161C6.12796 12.1043 6.12796 12.8957 6.61612 13.3839C7.10427 13.872 7.89573 13.872 8.38388 13.3839L10 11.7678L11.6161 13.3839C12.1043 13.872 12.8957 13.872 13.3839 13.3839C13.872 12.8957 13.872 12.1043 13.3839 11.6161L11.7678 10L13.3839 8.38388C13.872 7.89573 13.872 7.10427 13.3839 6.61612C12.8957 6.12796 12.1043 6.12796 11.6161 6.61612L10 8.23223L8.38388 6.61612Z',
    fill: 'fill-error-500',
  },
} as const;

interface ValidationStatusBadgeProps {
  type: keyof typeof ICON_STYLES;
  children: ReactNode;
  showBadge: boolean;
}

export const ValidationStatusBadge: FC<ValidationStatusBadgeProps> = ({ type, children, showBadge }) => {
  const style = ICON_STYLES[type];

  return (
    <div className="relative inline-flex">
      {children}
      {showBadge && (
        <div
          className={twMerge(
            'pointer-events-none absolute -top-1 -right-1 flex size-5 items-center justify-center rounded-full bg-white',
          )}
          data-testid="validation-count-badge"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" className={style.fill}>
            <path fillRule="evenodd" clipRule="evenodd" d={style.path} />
          </svg>
        </div>
      )}
    </div>
  );
};
